import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Button, Alert, Spinner, Tabs, Tab, OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import Moment from "react-moment";
import API from '../../Utility';
import { FaEdit, FaPlus, FaTimes, FaRegTrashAlt, FaCheck, FaCheckSquare, FaRegCheckSquare, FaDownload } from "react-icons/fa";
import useElementOnScreen from "../../Utility/useElementOnScreen";

export default function User({
  user,
  userIndex,
  project,
  setAssignmentToView,
  setShowConfirmView,
  setAssignUserMode,
  setEditUser,
  setShowAssignUsersFormModal,
  setAssignmentToDelete,
  setShowConfirmUnassign,
  itemsLoaded,
  setItemsLoaded,
}) {

  function calcIdealPercentageTransform(percentage) {
    if (percentage <= 25) {
      return 'translateX(0)';
    }
    if (percentage >= 75) {
      return 'translateX(-100%)';
    }
    return 'translateX(-50%)';
  }
  const [containerRef, isVisible] = useElementOnScreen({
    root: null,
    rootMargin: "0px",
    threshold: 1.0
  });


  useEffect(() => {
    if (isVisible) {
      if (!itemsLoaded.find((item) => item === `${user._id}`)) {
        let newItemsLoaded = [...itemsLoaded];
        newItemsLoaded.push(`${user._id}`);
        setItemsLoaded(newItemsLoaded);
      }
    }
  }, [isVisible]);

  return (
    <div key={userIndex} ref={containerRef}>
      <div key={user._id} className="workflow-users-list-item">
        <div className="workflow-users-list-item-part-a">
          <div className="workflow-progress-bar">
            <div className="workflow-start-end-dates">
              <Row style={{ fontSize: "12px", display: 'flex', flex: 2 }}>
                <Col style={{ fontSize: "12px", marginLeft: '15px' }}><div>Start Date: <Moment format="DD MMM 'YY">{user.startDate}</Moment></div></Col>
                <Col style={{ fontSize: "12px", padding: 0, textAlign: 'right' }}><div>End Date: <Moment format="DD MMM 'YY" add={{ days: user.endDay }}>{user.startDate}</Moment></div></Col>
              </Row>
            </div>
            <div style={{
              position: "relative",
              width: "100%",
              borderRadius: "5px"
            }}>
              <div style={{
                backgroundColor: "#eee",
                width: "100%",
                height: "10px",
                borderRadius: "5px",
              }}>
                <div style={{
                  backgroundColor: "#aaa",
                  width:  user?.progressInfo?.progressPercentage + "%",
                  height: "10px",
                  borderRadius: "5px",
                }}></div>
                <div style={{
                  position: "relative",
                  backgroundColor: "#444444",
                  left: user?.progressInfo?.idealPercentageCompleted + "%",
                  width: "2px",
                  height: "16px",
                  top: "-13px"
                }}></div>
              </div>
              <div style={{
                position: "absolute",
                width: "max-content",
                display: "inline-block",
                left: user?.progressInfo?.idealPercentageCompleted + "%",
                transform: calcIdealPercentageTransform(user?.progressInfo?.idealPercentageCompleted),
                fontSize: "12px",
                marginTop: '5px'
              }}>Where they should be</div>
            </div>
          </div>
          <div className="workflow-progress-dot">
            <OverlayTrigger
              placement={'top'}
              overlay={
                <Tooltip id="delete-tooltip-disabled">
                  <p>{user?.progressInfo?.status === 'Behind' ? 'There are tasks that are due (should have been completed by now)' : 'All tasks that are due are complete'}</p>
                </Tooltip>
              }
            >
              <div style={{
                position: "relative",
                backgroundColor: user?.progressInfo?.status === 'Behind' ? 'orange': 'green',
                width: "15px",
                height: "15px",
                borderRadius: "50%"
              }}></div>
            </OverlayTrigger>
          </div>
          <div className="workflow-display-name">{user.user.displayName}</div>
        </div>
        <div className="workflow-users-list-item-part-b">
          {
            <Button
              onClick={() => {
                setAssignmentToView(user);
                setShowConfirmView(true);
              }}
              variant="outline-secondary"
              style={{ display: 'flex', alignItems: 'center', marginRight: '10px'  }}
            >
              <FaCheck style={{ verticalAlign: "middle", marginRight: '10px' }} />
              <span style={{ verticalAlign: "middle" }}>All Tasks</span>
            </Button>
          }
          {
            (project?.userPermissions?.isWorkflowManager || project?.userPermissions?.isCurrentUserOwner || project?.userPermissions?.isCurrentUserAdmin) &&
            <Button
              onClick={() => {
                setAssignUserMode('update');
                setEditUser(user);
                setShowAssignUsersFormModal(true);
              }}
              variant="primary"
              style={{ display: 'flex', alignItems: 'center', color: '#fff', marginRight: '10px' }}
            >
              <FaEdit size="20px" style={{ verticalAlign: "middle", marginRight: '10px' }}></FaEdit>
              <span style={{ verticalAlign: "middle" }}>Edit</span>
            </Button>
          }
          {
            (project?.userPermissions?.isWorkflowManager || project?.userPermissions?.isCurrentUserOwner || project?.userPermissions?.isCurrentUserAdmin) &&
            <Button
              onClick={() => {
                setAssignmentToDelete(user);
                setShowConfirmUnassign(true);
              }}
              variant="outline-secondary"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              {/* <FaTimes size="20px" style={{ verticalAlign: "middle", marginRight: '10px' }}></FaTimes> */}
              <FaRegTrashAlt style={{ verticalAlign: "middle", marginRight: '10px' }} />
              <span style={{ verticalAlign: "middle" }}>Delete</span>
            </Button>
          }
        </div>
      </div>
    </div>
  );
}